export default {
  phone: '+62 21 50996971',
  offerLink: null,
  mailing: null,
  privacy: null,
  currency: 'Rp',
}
